import React from 'react'

import ZeusLogo from '../../../assets/zeus.png'
import RoadScienceLogo from '../../../assets/roadscience-horizontal.png'

import {
  FormContainer,
  FormSection,
  InputSection,
  FieldContainer,
  InputLabel,
  SignUpTitle,
  SignUpButton,
  StyledInput,
  FooterSection,
  SignInLinkContainer,
  SignInLink,
} from './styles'

const SignUpView = ({
  onSignUp,
  firstName,
  lastName,
  email,
  password,
  onValueChange,
  onBackToSignIn,
}) => (
  <FormContainer>
    <img src={ZeusLogo} alt="Zeus" style={{ height: 80, marginBottom: 16 }} />
    <FormSection>
      <SignUpTitle>Create your account</SignUpTitle>
      <form onSubmit={onSignUp}>
        <InputSection>
          <FieldContainer>
            <InputLabel>First Name *</InputLabel>
            <StyledInput
              type="text"
              placeholder="Enter your first name"
              value={firstName}
              onChange={onValueChange('firstName')}
            />
          </FieldContainer>
          <FieldContainer>
            <InputLabel>Last Name *</InputLabel>
            <StyledInput
              type="text"
              placeholder="Enter your last name"
              value={lastName}
              onChange={onValueChange('lastName')}
            />
          </FieldContainer>
          <FieldContainer>
            <InputLabel>Email *</InputLabel>
            <StyledInput
              type="text"
              name="email"
              placeholder="Email"
              value={email}
              onChange={onValueChange('email')}
            />
          </FieldContainer>
          <FieldContainer>
            <InputLabel>Password *</InputLabel>
            <StyledInput
              type="password"
              name="password"
              placeholder="Password"
              value={password}
              onChange={onValueChange('password')}
            />
          </FieldContainer>
        </InputSection>

        <FooterSection>
          <SignInLinkContainer>
            <span>Have an account? </span>
            <SignInLink onClick={onBackToSignIn}>Sign in</SignInLink>
          </SignInLinkContainer>
          <SignUpButton type="submit" value="CREATE ACCOUNT" />
        </FooterSection>
      </form>
    </FormSection>
    <img src={RoadScienceLogo} alt="Road Science" style={{ height: 32, marginTop: 24, opacity: 0.7 }} />
  </FormContainer>
)

export { SignUpView }
